import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Row, Col, Dropdown, Accordion } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//api
import { getAllLists } from 'api/lists';
//redux
import { companySelector } from "slices/company";
import { setBreadcrumbTitle } from 'slices/breadcrumbSlice';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//images
import menuBooks from 'assets/img/img_menu_books.png';

const CustomDropdown = ({ setShowOffCanvas, isDesktop, menu }) => {
  const location = useLocation();
  const [showMenu, setShowMenu] = useState(false);
  const [allLists, setAllLists] = useState([]);
  const [activeKey, setActiveKey] = useState(null);
  const MenuToggler = useRef(undefined);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(['header']);
  const { matters } = useSelector(companySelector);
  const { assignedLibrary } = useAssignedLibrary();
  const currentLanguage = i18n.language;

  const desktopText = t(menu[`text_${currentLanguage}`]?.toLocaleUpperCase() || menu.text.toLocaleUpperCase());
  const mobileText = `${t(menu[`text_${currentLanguage}`]?.toLocaleUpperCase() || menu.text.toLocaleUpperCase())} / (${t('materias')})`;

  useEffect(() => {
    const fetchLists = async () => {
      try {
        const response = await getAllLists();
        if (response && response?.data) {
          setAllLists(response.data?.results);
        }
      } catch (error) {
        console.error('Error al obtener listas:', error);
      }
    };

    fetchLists();
  }, []);


  const closeMenu = () => {
    if (MenuToggler.current) MenuToggler.current.click();
    if (setShowOffCanvas) setShowOffCanvas(false);
    setShowMenu(false);
  };

  const handleClick = (title) => {
    dispatch(setBreadcrumbTitle(title));
  };

  const foundNameList = (nameList) => {
    if (!allLists || !Array.isArray(allLists)) return null;


    const found = allLists.find((list) =>
      list.nombre === nameList
    );


    return found;
  }

  // Ordenar y dividir los elementos en tres columnas
  const sortedMatters = useMemo(() => {
    if (!matters || !Array.isArray(matters)) return [];
    return [...matters].sort((a, b) => {
      const nameA = a[`name_${i18n.language}`] || a.name || '';
      const nameB = b[`name_${i18n.language}`] || b.name || '';
      return nameA.localeCompare(nameB);
    });
  }, [matters, i18n.language]); 

  const columns = useMemo(() => {
    const numColumns = 3;
    const columnSize = Math.ceil(sortedMatters.length / numColumns);
    return Array.from({ length: numColumns }, (_, colIndex) =>
      sortedMatters.slice(colIndex * columnSize, (colIndex + 1) * columnSize)
    );
  }, [sortedMatters]);

  // Función para renderizar el menú de submenu
  const renderSubmenu = () => {
    return menu?.submenu?.map((item) => {
      if (!item) return null;
      const { text, url, id } = item;
      let finalUrl = '';
      if (typeof url === 'string') {
        finalUrl = url.trim();
        if (finalUrl.startsWith('/libelista')) {
          finalUrl = finalUrl.replace('/libelista', '');
        }
      } else if (typeof url === 'object' && url !== null) {
        finalUrl = `${url.pathname}${url.search || ''}`;
        if (finalUrl.startsWith('/libelista')) {
          finalUrl = finalUrl.replace('/libelista', '');
        }
      }

      const localizedText = item[`text_${i18n.language}`] || text;
      const processedText =
        text === 'Las librerías recomiendan'
          ? 'Recomiendan librerias'
          : text;

      const nameList = foundNameList(processedText);


      return (
        <Dropdown.Item
          className="text-uppercase customDropdown-item"
          as={Link}
          to={`/${assignedLibrary}${finalUrl}`}
          key={id}
          state={{
            list: (nameList?.id || id).toString(),
            ...(location.state || {})
          }}
          eventKey={url}
          onClick={() => {
            handleClick(text)
            closeMenu(); 
          }}
        >
          {localizedText}
        </Dropdown.Item>
      );
    });
  };



  return (
    <Dropdown className="customDrop" show={showMenu} onToggle={(isOpen) => setShowMenu(isOpen)}  >
      <Dropdown.Toggle ref={MenuToggler}>
        {isDesktop ? desktopText : mobileText}
      </Dropdown.Toggle>
      <Dropdown.Menu rootCloseEvent="click">
        <Row>
          <Col sm={12} md={12} lg={4} xl={4} className="d-flex flex-column justify-content-center align-items-center">
            <Dropdown.Item disabled>
              <img className="mb-2 mt-n5" src={menuBooks} alt="books.png" />
            </Dropdown.Item>
            {renderSubmenu()}
          </Col>
          <Col sm={12} md={12} lg={6} xl={8}>
            <p className="text-uppercase bg-light p-2 mb-2">{t('materias')}</p>
            <Accordion className="ml-3 d-flex flex-column flex-lg-wrap custom-accordion" activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
              <Row className="g-3">
                {columns.map((column, colIndex) => (
                  <Col xs={12} sm={12} md={12} lg={4} key={`column-${colIndex}`}>
                    {column.map((matt, index) => {
                      const data = {
                        ibics: Array.isArray(matt.genre_ibic) ? matt.genre_ibic.map(item => item.id).join(',') : ''
                      };
                      const translatedName = matt[`name_${i18n.language}`] || matt.name;
                      const formattedTitle = matt.name.replace(/\s+/g, '');
                      const url = matt.genre_ibic?.length > 0 ? `/${assignedLibrary}/lista/materias` : '/#';

                      // Si no tiene `genre_ibic`, renderiza como un enlace simple
                      if (!matt.genre_ibic || matt.genre_ibic.length === 0) {
                        return (
                          <Link
                            to={`${url}?title=${formattedTitle}`}
                            key={matt.name + '-' + index}
                            className="d-block m-0 px-0 w-auto hover-text border-bottom-item"
                            onClick={closeMenu}
                            title={matt.name}
                          >
                            {translatedName.toLocaleUpperCase()}
                          </Link>
                        );
                      }

                      return (
                        <Accordion.Item eventKey={`${colIndex}-${index}`} className="border-0" key={matt.name + '-' + index}>
                          <Accordion.Header as="div" className="p-0 m-0">
                            <Dropdown.Item
                              as={Link}
                              className="d-block m-0 px-0 w-auto"
                              to={`${url}?title=${formattedTitle}`}
                              state={data}
                              eventKey={url + `?title=${formattedTitle}`}
                              onClick={closeMenu}
                              title={matt.name}
                            >
                              {translatedName}
                            </Dropdown.Item>
                          </Accordion.Header>
                          <Accordion.Body as="div" className="p- d-flex flex-column">
                            {matt.genre_ibic &&
                              matt.genre_ibic.map((ibic) => {
                                const ibicDescription = ibic[`descripcion_${i18n.language}`] || ibic.descripcion;
                                return (
                                  <Link
                                    to={`${assignedLibrary}/lista/materias?title=${ibic.descripcion}`}
                                    key={`ibic-${ibic.id}`}
                                    state={{ ibics: ibic.id }}
                                    className="hover-text"
                                    onClick={() => {
                                      setActiveKey(null); 
                                      if (ibic.id) {
                                        closeMenu();
                                      }
                                    }}
                                  >
                                    {ibicDescription}
                                  </Link>
                                );
                              })}
                          </Accordion.Body>
                        </Accordion.Item>
                      );
                    })}
                  </Col>
                ))}
              </Row>
            </Accordion>
          </Col>
        </Row>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CustomDropdown;